import React from 'react';
import { Route } from 'react-router-dom';
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import { RoutePathProps } from '../../../AppRoutes/types';
import ResetPasswordPage from '../pages/ResetPasswordPage';

// Lazy load auth pages (paths are relative to this file)
const LoginPage = React.lazy(() => import('../pages/LoginPage'));
const RegisterPage = React.lazy(() => import('../pages/RegisterPage'));
const LockscreenPage = React.lazy(() => import('../pages/LockscreenPage'));
const ForgotPasswordPage = React.lazy(() => import('../pages/ForgotPasswordPage'));

const login: RoutePathProps = {
  name: "login",
  path: "/login",
  label: "Login",
  icon: PersonIcon,
};

const register: RoutePathProps = {
  name: "register",
  path: "/register",
  label: "Register",
  icon: LockIcon,
};

const lockscreen: RoutePathProps = {
  name: "lockscreen",
  path: "/lockscreen",
  label: "Lockscreen",
  icon: PersonIcon,
};

const forgotPassword: RoutePathProps = {
  name: "forgot-password",
  path: "/forgot-password",
  label: "Forgot password",
  icon: LockIcon,
};

const resetPassword: RoutePathProps = {
  name: "reset-password",
  path: "/reset-password",
  label: "Reset Password",
  icon: LockIcon,
};

const AuthRoutes = (
  <>
    <Route path={login.path} element={<LoginPage />} />
    <Route path={register.path} element={<RegisterPage />} />
    <Route path={lockscreen.path} element={<LockscreenPage />} />
    <Route path={forgotPassword.path} element={<ForgotPasswordPage />} />
    <Route path={resetPassword.path} element={<ResetPasswordPage />} />
  </>
);

export const authPaths = [login, register];
export default AuthRoutes;
